import { InverseHeader } from '@jouzen/ecom-components/layout';
import { Button } from '@jouzen/ecom-components/v3/Button';

import RichText from '@/app/components/RichText';
import SimpleHero from '@/app/components/SimpleHero';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const SizingPageHero = () => {
  const modalContext = useSizingPageModalContext();

  const onWatchGen4VideoClick = () => {
    modalContext.setOr4VideoVisible(true);
  };

  const onWatchGen3VideoClick = () => {
    modalContext.setOr3VideoVisible(true);
  };

  return (
    <InverseHeader enter>
      <SimpleHero
        additionalContent={
          <div className="flex flex-col items-center gap-5 lg:flex-row lg:gap-6">
            <Button
              onClick={onWatchGen4VideoClick}
              data-cy="sizing-hero-gen4-video-cta"
              variant="secondary-light"
            >
              <RichText messageKey="sizing_gen4_or4_video_label" />
            </Button>
            <Button
              onClick={onWatchGen3VideoClick}
              data-cy="sizing-hero-gen3-video-cta"
              variant="secondary-light"
            >
              <RichText messageKey="sizing_gen4_or3_video_label" />
            </Button>
          </div>
        }
        artDirectionImageProps={{
          localizedAlt: 'sizing_gen4_hero_img_alt',
          srcSet: [
            {
              media: '(max-width: 1023px)',
              src: 'blue-sky/sizing/or4-sizing-hero.jpg?ar=4:3&fit=crop&crop=focalpoint&fp-x=0.45&fp-y=0.5fp-z=1&exp=5&con=-10',
            },
            {
              media: '(min-width: 1024px)',
              src: 'blue-sky/sizing/or4-sizing-hero.jpg?ar=16:9&fit=crop&crop=focalpoint&fp-x=0.35&fp-y=0.6&fp-z=1.1&exp=5&con=-10',
            },
          ],
        }}
        data-cy="sizing-hero"
        eyebrowMessageKey="sizing_gen4_hero_eyebrow"
        textColor="light"
        titleMessageKey="sizing_gen4_hero_title"
      />
    </InverseHeader>
  );
};

export default SizingPageHero;
